'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseHierarchicalCodelist = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parseHierarchicalCodelist = exports.parseHierarchicalCodelist = function parseHierarchicalCodelist(sdmxJson, hierarchyId) {
  var hCodelist = R.pathOr({}, ['data', 'hierarchicalCodelists', 0], sdmxJson);
  var hierarchy = R.find(R.propEq('id', hierarchyId), hCodelist.hierarchies || []);

  var getParentedCodes = function getParentedCodes(codes, parent) {
    var ids = R.pluck('codeID', codes);

    var siblings = R.reduce(function (acc, code) {
      if (R.isEmpty(code.hierarchicalCodes || [])) {
        return acc;
      }
      return R.mergeRight(acc, getParentedCodes(code.hierarchicalCodes, code.id));
    }, {}, codes);

    return (0, _extends5.default)({}, siblings, (0, _defineProperty3.default)({}, parent, ids));
  };

  var getChildren = function getChildren(codes, parents) {
    var ids = R.pluck('codeID', codes);

    var children = R.reduce(function (acc, code) {
      if (R.isEmpty(code.hierarchicalCodes || [])) {
        return acc;
      }
      return (0, _extends5.default)({}, acc, getChildren(code.hierarchicalCodes, R.append(code.codeID, parents)));
    }, {}, codes);
    var key = R.isEmpty(parents) ? '#ROOT' : R.join('.', parents);
    return (0, _extends5.default)({}, children, (0, _defineProperty3.default)({}, key, ids));
  };

  return R.pipe(R.propOr([], 'hierarchicalCodes'), function (codes) {
    return getChildren(codes, []);
  })(hierarchy);
};